module.exports = __webpack_public_path__ + "img/some-msg2.ea2249f2.png";